import EventHandler from './dom/event-handler';
import SelectorEngine from './dom/selector-engine';
import Offcanvas from './offcanvas';

class Consent {
    constructor () {
        /** @type {HTMLDivElement} */
        this.consentElem = SelectorEngine.findOne("#consent-banner");
        /** @type {HTMLDivElement} */
        this.purposeContainer = SelectorEngine.findOne("#consent-purposes-content > .accordion-body");
        /** @type {HTMLTemplateElement} */
        this.purposeTemplate = SelectorEngine.findOne("#consent-purpose-elem");
        /** @type {Offcanvas} */
        this.consentObj = new Offcanvas(this.consentElem);
        /** @type {Map<string, boolean>} */
        this.purposes = new Map();

        this.purposes.set(location.hostname + " (Required functional cookies)", true);
        this.purposes.set(location.hostname + " (Optional cookies)", false);

        const hasSavedPurposes = this.loadSavedPurposes();
        this.setPurposes();
        if (hasSavedPurposes) {
            this.allow('selection');
        } else {
            this.consentObj.show();
        }

        EventHandler.on(SelectorEngine.findOne("#consent-selection"), 'click', () => {
            this.allow();
            this.consentObj.hide();
        });
        EventHandler.on(SelectorEngine.findOne("#consent-none"), 'click', () => {
            this.allow("none");
            this.consentObj.hide();
        });
        EventHandler.on(SelectorEngine.findOne("#consent-all"), 'click', () => {
            this.allow("all");
            this.consentObj.hide();
        });
    }

    loadSavedPurposes() {
        if (!localStorage.getItem("omeConsentSelected")) return false;

        const consentDate = localStorage.getItem("omeConsentDate");
        const consentMaxAge = new Date();
        consentMaxAge.setMonth(consentMaxAge.getMonth() + 4);
        if (!consentDate || consentDate > consentMaxAge) {
            localStorage.removeItem("omeConsentSelected");
            localStorage.removeItem("omeConsentPurposes");
            localStorage.removeItem("omeConsentDate");
            return false;
        }

        const consentPurposes = localStorage.getItem("omeConsentPurposes");
        if (!consentPurposes) return false;
        this.purposes = new Map(JSON.parse(consentPurposes));
        return true;
    }

    setPurposes() {
        const purposeElems = SelectorEngine.find("[data-ome-consent]");
        purposeElems.forEach(elem => {
            if (!this.purposes.has(elem.dataset.omeConsent)) {
                this.purposes.set(elem.dataset.omeConsent, false);
            }
        });

        for (const [purpKey, purpVal] of this.purposes) {
            /** @type {HTMLElement} */
            const purposeClone = this.purposeTemplate.content.cloneNode(true);

            /** @type {HTMLInputElement} */
            const cloneInput = purposeClone.querySelector(".form-check-input");
            cloneInput.id = "consent-" + purpKey.replace(/\s+/g, '-').toLowerCase();
            cloneInput.value = purpKey;
            cloneInput.checked = purpVal;
            if (purpKey == location.hostname + " (Required functional cookies)") {
                cloneInput.checked = true;
                cloneInput.disabled = true;
            }

            /** @type {HTMLLabelElement} */
            const cloneLabel = purposeClone.querySelector(".form-check-label");
            cloneLabel.htmlFor = cloneInput.id;
            cloneLabel.textContent = purpKey;

            this.purposeContainer.appendChild(purposeClone);
        }
    }

    /** @param {string} type "all", "selection" or "none" */
    allow(type = "selection") {
        for (const elem of SelectorEngine.find(".form-check-input", this.purposeContainer)) {
            if (type == "all") elem.checked = true;
            if (type == "none" && elem.value != location.hostname + " (Required functional cookies)") elem.checked = false;

            for (const consentElem of SelectorEngine.find("[data-ome-consent=\"" + elem.value + "\"]")) {
                if (elem.checked) {
                    consentElem.removeAttribute("type");
                    consentElem.removeAttribute("data-ome-consent");

                    const copy = document.createElement("script");
                    copy.innerHTML = consentElem.innerHTML;
                    for (const attr of consentElem.attributes) {
                        copy.setAttributeNode(attr.cloneNode());
                    }

                    document.head.appendChild(copy);
                    consentElem.remove();
                }
            }
            
            this.purposes.set(elem.value, elem.checked);
        };
        localStorage.setItem("omeConsentSelected", "true");
        localStorage.setItem("omeConsentPurposes", JSON.stringify(Array.from(this.purposes.entries())));
        localStorage.setItem("omeConsentDate", Date.now());
    }
}

EventHandler.one(document, 'DOMContentLoaded', () => {
    if (document.querySelector('#consent-banner')) new Consent();
});

export default Consent;
